import { addDays, subDays } from 'date-fns';

import { USER_LOGOUT_CLEAR } from 'constants/ActionTypes';
import { filterSliceAdapter } from 'modules/global/reducers/filterSliceAdapter';
import { tryParse } from 'utils/date';
import { createReducer } from 'utils/ReduxUtils';

import { getPersistedFilters } from '../../../services/StateLoader';
import * as actionTypes from '../actionTypes';

const persistedFilters = getPersistedFilters()?.filters?.safeCalendar ?? {};

const emptyState = {
  date: new Date(),
  brands: [],
  types: [],
  tasks: false,
  issues: false,
};

const filterAdapter = filterSliceAdapter(emptyState, persistedFilters);

const nextDay = state => ({
  ...state,
  date: state.date && addDays(tryParse(state.date), 1),
});

const previousDay = state => ({
  ...state,
  date: state.date && subDays(tryParse(state.date), 1),
});

const setDate = (state, { payload: date }) => ({
  ...state,
  date,
});

export default createReducer(filterAdapter.getInitialState(), {
  [actionTypes.SET_PLANNING_FILTER]: filterAdapter.setFilter,
  [actionTypes.SET_PLANNING_FILTERS]: filterAdapter.setFilters,
  [actionTypes.CLEAR_PLANNING_FILTERS]: filterAdapter.resetFilters,
  [actionTypes.REMOVE_PLANNING_FILTER]: filterAdapter.removeFilter,
  [actionTypes.INCREMENT_SELECTED_DAY]: nextDay,
  [actionTypes.DECREMENT_SELECTED_DAY]: previousDay,
  [actionTypes.SET_SELECTED_DAY]: setDate,
  [USER_LOGOUT_CLEAR]: filterAdapter.resetFilters,
});
